import React from 'react';

import Flickity from '../../../Flickity';
import Spinner from '../../../Spinner/Spinner';
import { FilterResult } from '../../Types';
import ProductSlideComponent from '../Products/ProductSlideComponent';

interface Props {
    headline: string;
    products: FilterResult[];
    // set this if slider is not updating
    // correctly (like showing disabled arrows)
    reloadOnUpdate: boolean;
    loading?: boolean;
}
const ProductSlider: React.FunctionComponent<Props> = (props) => {
    return (
        <div className="product-list product-list--slider">
            <h2 className="product-list__headline">{props.headline}</h2>
            {props.loading ? (
                <Spinner highPerformance={true} />
            ) : (
                <Flickity
                    className={'slider slider--product-slider'}
                    reloadOnUpdate={props.reloadOnUpdate}
                    options={{
                        contain: false,
                        pageDots: false,
                        groupCells: true,
                        prevNextButtons: props.products.length > 1,
                    }}
                >
                    {props.products.map((product) => (
                        <ProductSlideComponent key={product.articleNumber} product={product} />
                    ))}
                </Flickity>
            )}
        </div>
    );
};

export default ProductSlider;
